var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7.25V8H6.75C6.33579 8 6 8.33579 6 8.75C6 9.16421 6.33579 9.5 6.75 9.5H7.05L7.86493 17.6493C7.94161 18.4161 8.58685 19 9.35748 19H14.6425C15.4131 19 16.0584 18.4161 16.1351 17.6493L16.95 9.5H17.25C17.6642 9.5 18 9.16421 18 8.75C18 8.33579 17.6642 8 17.25 8H15V7.25C15 6.00736 13.9926 5 12.75 5H11.25C10.0074 5 9 6.00736 9 7.25ZM11.25 6.5C10.8358 6.5 10.5 6.83579 10.5 7.25V8H13.5V7.25C13.5 6.83579 13.1642 6.5 12.75 6.5H11.25ZM10.0504 10.0009C10.4641 9.98025 10.8163 10.2989 10.837 10.7125L11.112 16.2125C11.1326 16.6262 10.814 16.9784 10.4003 16.9991C9.98665 17.0197 9.63451 16.7011 9.61383 16.2875L9.33883 10.7875C9.31814 10.3738 9.63674 10.0216 10.0504 10.0009ZM13.9503 10.0009C14.364 10.0216 14.6826 10.3738 14.662 10.7875L14.387 16.2875C14.3663 16.7011 14.0141 17.0197 13.6004 16.9991C13.1867 16.9784 12.8681 16.6262 12.8888 16.2125L13.1638 10.7125C13.1845 10.2989 13.5366 9.98025 13.9503 10.0009Z",
    fill: "#171717",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.7febb6ad27d0f3e8d44cb11b0c3e7f60.svg";
export { ForwardRef as ReactComponent };